import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { FC, useState } from 'react'
import {
  SimpleAccordion,
  SimpleAccordionDetails,
  SimpleAccordionSummary,
} from '@sales-center/components'
import Box from '@mui/material/Box'
import { DetailLabel, ShowLink } from '../atoms'

interface Props {
  appointmentId: string
  techName: string
  scheduledBy: string
}

export const Details: FC<Props> = (props) => {
  const { techName, scheduledBy, appointmentId } = props

  const [open, setOpen] = useState<boolean>(false)
  const verb = open ? 'Hide' : 'Show'

  const onChange = React.useCallback(
    (_: React.ChangeEvent, isExpanded: boolean) => {
      setOpen(isExpanded)
    },
    [],
  )
  const theme = useTheme()
  return (
    <Box>
      <SimpleAccordion square onChange={onChange}>
        <SimpleAccordionSummary style={{ color: '#005aa3' }}>
          <ShowLink data-test-id={`details-link-${appointmentId}`}>
            {verb} Details
          </ShowLink>
        </SimpleAccordionSummary>
        <SimpleAccordionDetails
          style={{ margin: `${theme.spacing(0.8)} ${theme.spacing(1)} 0 0` }}
        >
          <Box display="flex" alignItems="flex-start" flexDirection="column">
            <Box>
              <DetailLabel>Tech/Sales: {techName}</DetailLabel>
            </Box>

            <Box paddingTop={0.4}>
              <DetailLabel>Scheduled by: {scheduledBy}</DetailLabel>
            </Box>
          </Box>
        </SimpleAccordionDetails>
      </SimpleAccordion>
    </Box>
  )
}

Details.displayName = 'Details'
